export default __webpack_public_path__ + "static/media/anti-slip_taupe.906aaf58.webp";